// extracted by mini-css-extract-plugin
export default {"modal":"CargandoInicio_modal__eSTAh","modal-content":"CargandoInicio_modal-content__8dAiV"};